import http from '../utils/http-common'
const getAll = (param) => {
  return http.get('/location-categories', { params: param })
}
const LocationCategoryDataService = {
  getAll,
}
export default LocationCategoryDataService
